import { keys } from './keys';

export const es = {
  [keys.banner.title]: 'Cookies',
};
